import React from "react";

const Impressum = () => (
  <>
    <section className="page-header">
      <h1>Impressum</h1>
    </section>
    <section className="impressum-section" style={{maxWidth: 700, margin: "3rem auto", background: "black", color: "#222", borderRadius: 4, padding: "2.5rem 1.5rem"}}>
      <p>
      <strong>CG Fliesen – Christoph Grabner</strong><br />
      Mitterdorf an der Raab 95<br />
      8181 Mitterdorf an der Raab<br />
      Österreich<br /><br />
      Tel: <a href="tel:+436642341947" style={{color:"#ffa726"}}>0664 / 2341947</a><br />
      E-Mail: <a href="mailto:cg-fliesen@gmx.at" style={{color:"#ffa726"}}>cg-fliesen@gmx.at</a><br /><br />
      <strong>Firmenbuchnummer:</strong> [falls vorhanden]<br />
      <strong>UID-Nummer:</strong> [falls vorhanden]<br />
      <strong>Gewerbeordnung:</strong> www.ris.bka.gv.at<br />
      <strong>Bezirkshauptmannschaft:</strong> Weiz<br /><br />
      <strong>Mitglied der Wirtschaftskammer Steiermark</strong><br /><br />
      <strong>Haftungsausschluss:</strong><br />
      Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.<br /><br />
      <strong>Urheberrecht:</strong><br />
      Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem österreichischen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
    </p>
  </section>
  </>
);

export default Impressum;
